/* Common Imports */

import React, { FC } from "react";

/* Library Imports */

import PreparePriceString from "../../../lib/PreparePriceString";

/* Interfaces */

interface CurrencyAmountProps {
	amount: number;
	currency: string | undefined;
}

/*

? Renders a price amount with the correct symbol and number system based on the
? currency stored on the resource. AED uses the dirham glyph (U+E001) from the
? CurrencySymbols font (registered globally in public/fonts/poppins/poppins.css)
? together with international (K/M/B) formatting. Anything else falls back to ₹
? with Indian (K/L/Cr) formatting.

*/

const CurrencyAmount: FC<CurrencyAmountProps> = ({ amount, currency }) => {
	const isAED = currency === "AED";
	const formatted = PreparePriceString(amount, isAED ? "international" : "indian");

	return (
		<React.Fragment>
			{isAED ? (
				<span style={{ fontFamily: "CurrencySymbols", marginRight: "0.25rem" }}>{String.fromCharCode(0xe001)}</span>
			) : (
				"₹"
			)}
			{formatted}
		</React.Fragment>
	);
};

export default CurrencyAmount;
